import Vue from "vue";

/**
 *
 * @param data
 * @returns {*}
 */
export function importRecordsCreate(data) {
  return Vue.axios({
    url: '/api/import_records/create',
    method: 'post',
    data
  })
}

/**
 *
 * @param data
 * @returns {*}
 */
export function importRecordsUpdate(data) {
  return Vue.axios({
    url: '/api/import_records/update',
    method: 'post',
    data
  })
}

/**
 * 导入记录列表
 * @param params
 * @returns {*}
 */
export function importRecordsList(params) {
  return Vue.axios({
    url: '/api/import_records/list',
    method: 'get',
    params
  })
}
